export default "__VITE_ASSET__DXsV$_vQ__"